
import bg1 from "../../images/slider/slider_hydreaulys1.jpg";
import bg2 from "../../images/slider/hydreaulys_val_gally.jpg";
import bg3 from "../../images/slider/hydreaulys_val_gally2.jpg";
import bg4 from "../../images/slider/hydreaulys_patrimoine.jpg";
import bg5 from "../../images/slider/1.jpg";
import bg6 from "../../images/slider/2.jpg";
import bg7 from "../../images/slider/3.jpg";
import bg8 from "../../images/slider/4.jpg";

import { Slider } from "@/src/data/types";
import Autoplay from "embla-carousel-autoplay";
import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { getAllSliders } from "../../API/Slider/sliderService";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "../../components/ui/carousel";
import user from "../../images/icons/user.png";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const bgImages = [
  { id: "1", image: bg1 },
  { id: "2", image: bg2 },
  { id: "3", image: bg3 },
  { id: "4", image: bg4 },
  { id: "5", image: bg5 },
  { id: "6", image: bg6 },
  { id: "7", image: bg7 },
  { id: "8", image: bg8 },
];

const HomeSection = () => {
  const [sliders, setSliders] = useState<Slider[]>([]);
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState(null);

  const fetchData = async () => {
    const response = await getAllSliders();
    setSliders(response?.sliders);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value); // ✅ Update keyword state
  };

  const navigate = useNavigate();
  const handleSearchClick = () => {
    if (!keyword.trim()) return;

    // Redirect to /search with keyword as a query parameter
    navigate(`/recherche?keyword=${encodeURIComponent(keyword)}`);
  };

  return (
    <>
      <div className="relative p-24 ">
        <div className="absolute inset-0">
          <Carousel
            opts={{ loop: true }}
            plugins={[
              Autoplay({
                delay: 2000,
              }),
            ]}
          >
            <CarouselContent>
              {bgImages.map((slider) => (
                <CarouselItem key={slider.id}>
                  <div
                    className="relative"
                    style={{
                      height: "700px",
                      width: "100%",
                    }}
                  >
                    <img
                      src={slider.image}
                      alt={`Carousel Image ${slider.id}`}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      className="absolute inset-0"
                      style={{
                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))`,
                        zIndex: 1,
                      }}
                    ></div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div></div>
          </Carousel>
        </div>

        <div className="relative mt-20">
          <div className="items-center text-5xl font-bold text-center text-white md:text-7xl">
            Hydreaulys
          </div>
          <div className="text-2xl font-bold text-center text-white mt-14 md:text-5xl">
            Ici commence la rivière
          </div>
        </div>

        <div className="hidden text-center md:mt-12 md:block">
          <div className="relative mx-auto w-[600px]">
            {/* Wrapper for the input, icon, and button */}
            <div className="relative flex items-center">
              {/* Search Icon */}
              <div className="absolute pointer-events-none left-3">
                <CiSearch className="w-5 h-5 text-black" />
              </div>

              {/* Search Input */}
              <Input
                className="py-3 pl-12 pr-12 text-black bg-white border border-gray-300 h-9 rounded-3xl focus:outline-none focus:border-primary"
                placeholder="Que cherchez vous..."
                value={keyword}
                onChange={handleInputChange}
              />

              {/* Search Button */}
              <Button
                className="absolute top-0 bottom-0 right-0 px-6 py-3 text-white rounded-r-md bg-primary rounded-3xl"
                onClick={handleSearchClick}
              >
                Rechercher
              </Button>
            </div>
          </div>

          <div className="absolute right-0 bottom-4">
            <a
              href="https://portail.eauxseineouest.fr/DocuWareProxy/sso?returnUrl=/home"
              target="_blank"
              rel="noreferrer"
            >
              <Button className="w-24 rounded-none h-14">
                <div className="flex items-center justify-center space-x-2">
                  <div>
                    <img src={user} alt="" className="text-white " />
                  </div>
                  <div>ELU</div>
                </div>
              </Button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSection;
